import React, { useRef, useState } from 'react';
import { colors } from '../../lib/colors';
import { getItemWithExpiration } from '../../lib/utils';
import { useAdminAlertsUnreadCountQuery } from '../../services/useAdminAlertsService';
import AlertCenterPanel from './AlertCenterPanel';

import BellIcon from './BellIcon';

interface AlertCenterBellProps {
    isOpen?: boolean;
    onOpenChange?: (open: boolean) => void;
}

const AlertCenterBell: React.FC<AlertCenterBellProps> = ({ isOpen: controlledOpen, onOpenChange }) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
    const isControlled = controlledOpen !== undefined;
    const isOpen = isControlled ? Boolean(controlledOpen) : uncontrolledOpen;
    const setIsOpen = (next: boolean) => {
        if (!isControlled) setUncontrolledOpen(next);
        onOpenChange?.(next);
    };
    const accessToken = getItemWithExpiration('authorization') ?? '';

    const { data } = useAdminAlertsUnreadCountQuery({ accessToken });
    const count = data?.count ?? 0;
    const display = count > 99 ? '99+' : String(count);

    return (
        <div className="relative">
            <button
                ref={buttonRef}
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="알림센터"
                className={`relative flex items-center justify-center w-[40px] h-[40px] rounded-[14px] border transition-all duration-200 ${
                    isOpen
                        ? 'bg-[#EFF6FF] border-[#BFDBFE]'
                        : 'bg-[#FFFFFF] border-[#E2E8F0] hover:bg-[#F8FAFC]'
                }`}
                style={{
                    boxShadow: isOpen
                        ? '0 10px 24px rgba(37, 99, 235, 0.12)'
                        : '0 8px 20px rgba(15, 23, 42, 0.05)',
                }}
            >
                <BellIcon size={18} color={isOpen ? colors.primary : '#0F172A'} />
                {count > 0 && (
                    <span
                        className="absolute -top-[2px] -right-[2px] min-w-[18px] h-[18px] px-[5px] rounded-full flex items-center justify-center"
                        style={{
                            backgroundColor: '#DC2626',
                            color: '#FFFFFF',
                            fontSize: 10,
                            fontWeight: 700,
                            lineHeight: '14px',
                            border: '2px solid #FFFFFF',
                        }}
                    >
                        {display}
                    </span>
                )}
            </button>

            {isOpen && <AlertCenterPanel onClose={() => setIsOpen(false)} anchorRef={buttonRef} />}
        </div>
    );
};

export default AlertCenterBell;
